<div class="container-fluid">
  <div class="form-horizontal">
    <div class="row">
      <div class="col-sm-6">
        <h3>
          {{ 'events.registration.management.tab-title' | translate | titlecase }}
          <span>
            <a href="https://support.weblinkinternational.com/hc/en-us/articles/115002325268" target="_blank"
              ><img
                src="/assets/img/help.png"
                title="{{ 'events.registration.management.tab-title-help' | translate }}"
                class="wc-help-icon"
            /></a>
          </span>
          <span class="wl-event-reg-refresh-link">
            <a href="#" (click)="$event.preventDefault(); resetAndSearch()">
              {{ 'common.refresh' | translate | titlecase }}
            </a>
          </span>
        </h3>
      </div>
      <div class="col-sm-6 text-right text-left-xs">
        {{ unfilteredRegistrationSearchResult.TotalCount }}
        {{ 'events.registration.management.total-count-label' | translate | titlecase }}
        (<a href="#" (click)="$event.preventDefault(); handleAttendeesWithNoProfileIdClick()"
          >{{ unfilteredRegistrationSearchResult.RegistrationsWithoutProfileCount }}
          {{ 'events.registration.management.total-without-profileid-count-label' | translate }}</a
        >)
      </div>
    </div>

    <div class="form-group">
      <div class="col-sm-6">
        <div class="input-group">
          <input type="text" class="form-control" [(ngModel)]="searchParams.Keyword" wl-on-enter-press (onEnterPess)="search()" />
          <span class="input-group-btn">
            <button
              pButton
              type="button"
              class="btn btn-default"
              (click)="search()"
              [disabled]="isSearching"
              [icon]="!isSearching ? 'pi pi-search' : ''"
            >
              <wl-busy *ngIf="isSearching" [show]="isSearching"></wl-busy>
            </button>
            <button
              pButton
              type="button"
              class="btn btn-default"
              (click)="resetAndSearch()"
              [disabled]="isSearching"
              icon="pi pi-times-circle"
            ></button>
          </span>
        </div>
      </div>

      <div class="col-sm-6">
        <select class="form-control" [(ngModel)]="searchParams.OrderBy" (ngModelChange)="getRegistrations()">
          <option value="">--{{ 'common.sort-by' | translate | titlecase }}--</option>
          <option
            *ngFor="let sortBy of sortByFields"
            [value]="sortBy.value"
            [selected]="sortBy.value == searchParams.OrderBy ? true : null"
          >
            {{ 'common.sort-by' | translate | titlecase }}: {{ sortBy.name }}
          </option>
        </select>
      </div>
    </div>

    <div class="form-group">
      <div class="col-sm-12">
        <button
          type="button"
          class="btn btn-sm btn-default"
          [ngClass]="{ 'wl-event-reg-open-close-open': showAdvancedSearch }"
          (click)="toggleAdvancedSearch()"
        >
          <span class="wl-event-reg-open-close-icon glyphicon glyphicon-chevron-down"></span>
        </button>
        {{ 'common.advancedSearch' | translate | titlecase }}
      </div>
    </div>

    <div *ngIf="showAdvancedSearch">
      <div class="form-group">
        <div class="col-sm-12">
          <p>{{ 'events.registration.management.sign-up-date-label' | translate | titlecase }}</p>

          <span class="wl-give-calendar-right-padding date-selector-container">
            <wl-date-selector [(ngModel)]="searchParams.SignUpStartDate" [disabled]="searchParams.SearchAnySignUpDate"></wl-date-selector>
            <wl-date-selector [(ngModel)]="searchParams.SignUpEndDate" [disabled]="searchParams.SearchAnySignUpDate"></wl-date-selector>
          </span>

          <label
            ><input type="checkbox" [(ngModel)]="searchParams.SearchAnySignUpDate" />
            {{ 'events.registration.management.search-any-date-label' | translate | titlecase }}</label
          >
        </div>
      </div>

      <div class="form-group">
        <div class="col-sm-6">
          <p>{{ 'events.registration.management.advanced-common-criteria-label' | translate | titlecase }}</p>

          <label>
            <input type="checkbox" [(ngModel)]="searchParams.AllUnpaid" />
            {{ 'events.registration.management.show-all-unpaid-label' | translate | titlecase }}
          </label>
          <br />
          <label>
            <input type="checkbox" [(ngModel)]="searchParams.AllWithBlankAttendees" />
            {{ 'events.registration.management.show-all-with-blank-attendees-label' | translate | titlecase }}
          </label>
          <br />
          <label>
            <input type="checkbox" [(ngModel)]="searchParams.AllWithProfileIdNotAssigned" />
            {{ 'events.registration.management.show-all-with-no-profile-id-assigned-label' | translate | titlecase }}
          </label>
          <br />
          <label>
            {{ 'events.registration.management.invoice-number-label' | translate | titlecase }}
            <input type="number" [(ngModel)]="searchParams.InvoiceNumber" />
          </label>

          <p>
            <button
              pButton
              type="button"
              class="btn btn-default"
              (click)="search()"
              [disabled]="isSearching"
              [icon]="!isSearching ? 'pi pi-search' : ''"
            >
              <wl-busy *ngIf="isSearching" [show]="isSearching"></wl-busy>
              <span [hidden]="isSearching">{{ 'common.search' | translate | titlecase }}</span>
              <span [hidden]="!isSearching">{{ 'common.searching' | translate | titlecase }}</span>
            </button>
          </p>
        </div>
        <div class="col-sm-6">
          <p>{{ 'events.registration.management.event-items-label' | translate | titlecase }}</p>
          <div class="event-items-container">
            <div *ngFor="let item of eventItems">
              <label>
                <input type="checkbox" [(ngModel)]="item.Selected" />
                {{ item.Descr }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group">
      <div class="col-sm-12">
        <div class="input-group">
          <select class="form-control" [(ngModel)]="selectedAction" (ngModelChange)="actionChanged($event)">
            <option *ngFor="let action of actions" [value]="action.value" [selected]="action.value == selectedAction ? true : null">
              {{ action.name }}
            </option>
          </select>
          <span class="input-group-btn">
            <button pButton type="button" class="btn btn-primary" (click)="executeAction()" icon="pi pi-play-circle"></button>
            <wl-busy [show]="exporting"></wl-busy>
            <img src="/assets/img/help.png" title="{{ 'events.registration.management.actions-help' | translate }}" class="wc-help-icon" />
          </span>
        </div>
      </div>
    </div>

    <div class="form-group">
      <div class="col-sm-12">
        <div class="event-list wc-with-cards wc-with-prime-list">
          <div [hidden]="isSearching || registrationSearchResult.Result.length">
            {{ 'events.registration.management.no-registrations-message' | translate }}
          </div>
          <p-dataView
            #registrationsDataGrid
            [lazy]="true"
            [rows]="10"
            [value]="registrationSearchResult.Result"
            [paginator]="true"
            (onLazyLoad)="lazyLoadRegistrations($event)"
            [totalRecords]="registrationSearchResult.TotalCount"
            layout="grid"
          >
            <ng-template let-cols let-registrations pTemplate="gridItem">
              <div class="card card-override" data-cy="divRegistrationManagementCardContainer" *ngFor="let registration of registrations">
                <div class="card-block">
                  <div class="wc-card-controls pull-right">
                    <input type="checkbox" [(ngModel)]="registration.Selected" />
                  </div>
                  <h4 class="card-title">
                    <wl-profile-type-icon
                      [isMember]="registration.Member"
                      [isOrg]="registration.OrgInd"
                      [profileId]="registration.ProfileID"
                      [memberTypeIconColor]="registration.MemberTypeIconColor"
                    ></wl-profile-type-icon>
                    <a href="#" (click)="$event.preventDefault(); editRegistration(registration)">
                      <span *ngIf="registration.ProfileID > 0"
                        >{{ registration.ProfileReportName || registration.DisplayName }}&nbsp;({{ registration.ProfileID }})</span
                      >
                      <span *ngIf="registration.ProfileID <= 0"
                        >{{ registration.DisplayName }}&nbsp;({{
                          'events.registration.management.no-profile-label' | translate | titlecase
                        }})</span
                      >
                    </a>
                  </h4>
                  <div class="card-text" *ngIf="registration.OrgInd == true">
                    {{ registration.FirstName }}&nbsp;{{ registration.LastName }}
                  </div>
                  <div class="card-text">
                    {{ registration.SignUpDate | date: 'MM/dd/yyyy' }}
                  </div>
                  <div class="card-text" *ngIf="registration.Email != ''">
                    <a [href]="'mailto:' + registration.Email">{{ registration.Email }}</a>
                  </div>
                  <div class="card-text">
                    {{ registration.ItemsDisplay }}
                  </div>

                  <p class="card-text">
                    <b>
                      {{ 'common.revenue.total' | translate | titlecase }}&nbsp;{{ registration.AmountInvoiced | currency }}&nbsp;&nbsp;{{
                        'common.revenue.amount-due' | translate | titlecase
                      }}&nbsp;<span class="text-danger" *ngIf="registration.AmountInvoiced - registration.AmountPaid > 0">{{
                        registration.AmountInvoiced - registration.AmountPaid | currency
                      }}</span
                      ><span *ngIf="registration.AmountInvoiced - registration.AmountPaid <= 0">{{
                        registration.AmountInvoiced - registration.AmountPaid | currency
                      }}</span></b
                    >
                  </p>

                  <p class="card-text">
                    <button
                      type="button"
                      class="btn btn-xs btn-default"
                      data-cy="btnRegistrationManagementShowAttendees"
                      [ngClass]="{ 'wl-event-reg-open-close-open': registration.ShowDetails }"
                      title="{{ 'common.show' | translate | titlecase }} {{ 'common.details' | translate | titlecase }}"
                      (click)="toggleDetails(registration)"
                    >
                      <span class="wl-event-reg-open-close-icon glyphicon glyphicon-chevron-down"></span>
                    </button>
                    {{ 'events.registration.management.registration-attendees-header-label' | translate | titlecase }}
                    <span [hidden]="!registration.UnkownAttendeesCount">
                      ({{ registration.UnkownAttendeesCount }} {{ 'events.registration.management.unknown-out-of' | translate }}
                      {{ registration.PotentialAttendeeCount }})
                    </span>
                    <wl-busy [show]="registration.LoadingDetails"></wl-busy>
                  </p>
                </div>

                <ul class="list-group list-group-flush" *ngIf="registration.ShowDetails">
                  <li class="list-group-item" *ngFor="let attendee of registration.Attendees">
                    {{ attendee.FName }}&nbsp;{{ attendee.LName }}&nbsp;(<span *ngIf="attendee.ProfileID > 0">{{ attendee.ProfileID }}</span
                    ><span *ngIf="!(attendee.ProfileID > 0)">{{
                      'events.registration.management.no-profile-label' | translate | titlecase
                    }}</span
                    >)
                  </li>
                </ul>

                <div class="mb-20 mh-20 mct-flex mct-row mct-justify-between mct-items-center">
                  <div>
                    <button
                      type="button"
                      class="atlas-btn atlas-btn-default mr-10"
                      data-cy="btnRegistrationManagementEdit"
                      [disabled]="launchedModal"
                      (click)="editRegistration(registration)"
                      title="{{ 'common.edit' | translate | titlecase }} ({{ registration.Id }})"
                    >
                      {{ 'common.edit' | translate | uppercase }}
                    </button>
                    <button
                      type="button"
                      class="atlas-btn atlas-btn-default mr-10"
                      data-cy="btnRegistrationManagementViewInvoice"
                      title="{{ 'events.registration.management.invoice-number' | translate | titlecase }}{{ registration.InvoiceNum }}"
                      (click)="viewInvoice(registration)"
                      [hidden]="registration.InvoiceNum == 0"
                    >
                      {{ 'events.registration.management.view-invoice' | translate | uppercase }}
                    </button>
                    <button
                      *wlAccessControl="editInvoiceAccessControl"
                      type="button"
                      class="atlas-btn atlas-btn-default"
                      data-cy="btnRegistrationManagementEditInvoice"
                      (click)="goToInvoiceEdit(registration)"
                      title="{{ 'events.registration.management.edit-invoice' | translate | titlecase }}"
                    >
                      {{ 'events.registration.management.edit-invoice' | translate | uppercase }}
                    </button>
                  </div>
                  <span [wl-busy-overlay]="registration._loadingConfirmationMessage" [busyCenter]="true"> </span>
                  <div>
                    <action-button styleClass="atlas-btn-default" icon="pi pi-ellipsis-h" [items]="registration._menuItems">
                    </action-button>
                  </div>
                </div>
              </div>
            </ng-template>
          </p-dataView>
        </div>
      </div>
    </div>
  </div>

  <app-back-to-top></app-back-to-top>
</div>

<wl-registration-delete #deleteDialog (onDialogResult)="registrationDeleteDialogHandler($event)"></wl-registration-delete>
<wl-registration-management-selector
  #registrationSelector
  (confirmed)="handleRegistrationSelectorOkClick($event)"
></wl-registration-management-selector>
